import { Routes } from '@angular/router';
import { adminCanMatch } from './admin/admin.guard';
import { signedInCanMatch } from './auth/signed-in.guard';
import { vipCanMatch } from './auth/vip.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.page').then((m) => m.HomePage)
  },
  {
    path: 'search',
    loadComponent: () => import('./pages/search/search.page').then((m) => m.SearchPage)
  },
  {
    path: 'collections',
    loadComponent: () =>
      import('./pages/collections/collections.page').then((m) => m.CollectionsBrowsePage)
  },
  {
    path: 'collections/:idOrSlug',
    loadComponent: () =>
      import('./pages/collections/collection-detail.page').then((m) => m.CollectionDetailPage)
  },
  {
    path: 'movies',
    loadComponent: () => import('./pages/movies/movies.page').then((m) => m.MoviesPage)
  },
  {
    path: 'movies/:idOrSlug/play',
    loadComponent: () =>
      import('./pages/movies/movie-playback.page').then((m) => m.MoviePlaybackPage)
  },
  {
    path: 'movies/:idOrSlug',
    loadComponent: () =>
      import('./pages/movies/movie-detail.page').then((m) => m.MovieDetailPage)
  },
  {
    path: 'series',
    loadComponent: () => import('./pages/series/series.page').then((m) => m.SeriesPage)
  },
  {
    path: 'series/:idOrSlug/episodes/:episodeId/play',
    loadComponent: () =>
      import('./pages/series/series-playback.page').then((m) => m.SeriesPlaybackPage)
  },
  {
    path: 'series/:idOrSlug',
    loadComponent: () =>
      import('./pages/series/series-detail.page').then((m) => m.SeriesDetailPage)
  },
  {
    path: 'people/:personId',
    loadComponent: () =>
      import('./pages/people/person-detail.page').then((m) => m.PersonDetailPage)
  },
  {
    path: 'news',
    loadComponent: () => import('./pages/news/news-list.page').then((m) => m.NewsListPage)
  },
  {
    path: 'news/:id',
    loadComponent: () => import('./pages/news/news-detail.page').then((m) => m.NewsDetailPage)
  },
  {
    path: 'profile',
    canMatch: [signedInCanMatch],
    loadComponent: () => import('./pages/profile/profile.page').then((m) => m.ProfilePage)
  },
  {
    path: 'history',
    canMatch: [signedInCanMatch],
    loadComponent: () =>
      import('./pages/history/watch-history.page').then((m) => m.WatchHistoryPage)
  },
  {
    path: 'my-collections',
    canMatch: [vipCanMatch],
    loadComponent: () =>
      import('./pages/my-collections/my-collections.page').then((m) => m.MyCollectionsPage)
  },
  {
    path: 'my-collections/:id',
    canMatch: [vipCanMatch],
    loadComponent: () =>
      import('./pages/my-collections/my-collection-detail.page').then(
        (m) => m.MyCollectionDetailPage
      )
  },
  {
    path: 'admin',
    canMatch: [adminCanMatch],
    loadComponent: () =>
      import('./pages/admin/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/admin/dashboard/dashboard.page').then((m) => m.DashboardPage)
      },
      {
        path: 'users',
        pathMatch: 'full',
        redirectTo: 'users/stats'
      },
      {
        path: 'users/stats',
        loadComponent: () =>
          import('./pages/admin/users/users-stats.page').then((m) => m.UsersStatsPage)
      },
      {
        path: 'users/list',
        loadComponent: () =>
          import('./pages/admin/users/users-list.page').then((m) => m.UsersListPage)
      },
      {
        path: 'users/vip-levels',
        loadComponent: () =>
          import('./pages/admin/users/vip-levels.page').then((m) => m.VipLevelsPage)
      },
      {
        path: 'jobs',
        loadComponent: () => import('./pages/admin/jobs/jobs.page').then((m) => m.AdminJobsPage)
      },
      {
        path: 'playback',
        loadComponent: () =>
          import('./pages/admin/playback/playback.page').then((m) => m.AdminPlaybackPage)
      },
      {
        path: 'data',
        loadComponent: () => import('./pages/admin/data/data.page').then((m) => m.DataPage)
      },
      {
        path: 'data/countries',
        loadComponent: () =>
          import('./pages/admin/data/countries/countries.page').then((m) => m.CountriesPage)
      },
      {
        path: 'data/genres',
        loadComponent: () =>
          import('./pages/admin/data/genres/genres.page').then((m) => m.GenresPage)
      },
      {
        path: 'data/collections',
        loadComponent: () =>
          import('./pages/admin/data/collections/collections.page').then((m) => m.CollectionsPage)
      },
      {
        path: 'data/collections/new',
        loadComponent: () =>
          import('./pages/admin/data/collections/collection-form.page').then(
            (m) => m.AdminCollectionFormPage
          )
      },
      {
        path: 'data/collections/:id/edit',
        loadComponent: () =>
          import('./pages/admin/data/collections/collection-form.page').then(
            (m) => m.AdminCollectionFormPage
          )
      },
      {
        path: 'data/movies',
        loadComponent: () =>
          import('./pages/admin/data/movies/movies.page').then((m) => m.AdminMoviesPage)
      },
      {
        path: 'data/movies/new',
        loadComponent: () =>
          import('./pages/admin/data/movies/movie-form.page').then((m) => m.AdminMovieFormPage)
      },
      {
        path: 'data/movies/:id/edit',
        loadComponent: () =>
          import('./pages/admin/data/movies/movie-form.page').then((m) => m.AdminMovieFormPage)
      },
      {
        path: 'data/series',
        loadComponent: () =>
          import('./pages/admin/data/series/series.page').then((m) => m.AdminSeriesPage)
      },
      {
        path: 'data/series/new',
        loadComponent: () =>
          import('./pages/admin/data/series/series-form.page').then((m) => m.AdminSeriesFormPage)
      },
      {
        path: 'data/series/:id/edit',
        loadComponent: () =>
          import('./pages/admin/data/series/series-form.page').then((m) => m.AdminSeriesFormPage)
      },
      {
        path: 'data/people',
        loadComponent: () =>
          import('./pages/admin/data/people/people.page').then((m) => m.AdminPeoplePage)
      },
      {
        path: 'data/news',
        loadComponent: () =>
          import('./pages/admin/data/news/news.page').then((m) => m.AdminNewsPage)
      }
    ]
  },
  { path: '**', redirectTo: 'home' }
];
